
<div class="grid" *ngIf="(articles$ | push) as articles" >	  
	  <app-card 
	  	class="article-wrapper"
	  	*ngFor="let article of articles; trackBy: trackByMethod" 
	  	[article]="article" 
	  	[displayPage]="displayPage" 
	  	[queryParams]="(queryParams$ | push)"
	  	[orphan]="orphan"
			
	  ></app-card>
</div>